import { formatUnits } from 'ethers/lib/utils';
import { expandDecimals, FERRO_LP_DECIMALS, USD_DECIMALS } from './constants';
import VenoStormModule from './venoStorm';
import WcroYVaultModule from './wcroYVault';
export default class FerroLpYVaultModule extends WcroYVaultModule {
    constructor() {
        super(...arguments);
        this.contractAddress = this.sdk.addresses.ferroLpYVault;
        this.venoStorm = new VenoStormModule(this.sdk);
    }
    async getTokenAssetPrice() {
        const usdBn = await this.venoStorm.getLpValueUsdV2('FERRO', expandDecimals(1, FERRO_LP_DECIMALS));
        return Number(formatUnits(usdBn, USD_DECIMALS));
    }
}
